module.exports = __webpack_public_path__ + "img/frame (74).5be8313f.jpg";